var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ScrollTopComponent',[_c('a',{staticClass:"btn btn-light"},[_c('img',{attrs:{"src":require("../assets/arrow-up.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }